import request from '@/utils/request'

/**
 * 获取列表
 */
function getPagelist(data) {
  return request({
    url: '/feedback/getFeedbackPageList',
    method: 'post',
    data
  })
}

/**
 * 回复
 * @param {*} data
 */
function replyData(data) {
  return request({
    url: '/feedback/createReplied',
    method: 'post',
    data
  })
}

/**
 * 查看
 * @param {*} data
 */
function viewData(data) {
  return request({
    url: '/feedback/getFeedbackReplied',
    method: 'post',
    data
  })
}

/**
 * 导出
 * @param {*} data
 */
function exprotHandle(data) {
  return request({
    url: '/feedback/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
export {
  getPagelist,
  exprotHandle,
  replyData,
  viewData
}
